export const HABITABLE_PROPERTIES_ID = "potentialImpactsHabitableProperties";
export const CLUSTER_MAX_ZOOM = 16;
export const MAX_HOURS = 11;
export const ICON_HOUSE = "marker-house";
export const ICON_MULTI_HOUSE = "marker-multi-house";
